export default "__VITE_ASSET__CqSy65sh__"